module.exports = __webpack_public_path__ + "img/tuxsuite_green_icons-03.5a8916ba.png";